namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class GAdmVyberovaSkupinaDialog extends GContentBase {
        private data: Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaObsahSaveDto[];
        private canAddVyberovaSkupina: boolean;
        private typ_subj: number;
        private ixs_fun: string;

        private srv: GContent

        private getSrv(): GContent {
            if (this.srv == undefined || this.srv == null)
                this.srv = this.createServiceContent("Gordic.Adm.WebControls.GAdmVyberovaSkupinaDialog");
            return this.srv;
        }

        onContentReady() {
            this.init();
        }

        private init() {
            this.createActions();
            this.createForm();
            this.createCommandBar();
            this.createInfoFlash();
        }

        private createActions() {
            this.actions.addRange({
                actAddVyberovaSkupina: {
                    caption: "jres:33000445", //RC 33000445 : Nová výběrová skupina
                    icon: "gi-plus",
                    captionVisible: "never",
                    run: () => {
                        this.createNewVyberovaSkupina();
                    }
                },
                actVyberovaSkupinaCancel: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                },
                actVyberovaSkupinaOK: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.vyberovaSkupinaOK(ev);
                    }
                },
                actSaveDataVyberovaSkupina: {
                    caption: "jres:32131041",
                    run: (ev, ctx) => {
                        this.saveDataVyberovaSkupina(ev);
                    }
                }
            })
        }

        private createCommandBar() {
            this.commandBar(this.actions.createBar(["actVyberovaSkupinaCancel*",
                {
                    action: this.actions.actSaveDataVyberovaSkupina,
                    primary: true
                }
            ]))
        }

        private createInfoFlash() {
            this.showFlash({
                state: "info",
                content: String.Format("jres:33000449", this.data.length) //RC 33000449 : Počet vybraných záznamů: {0}.
            })
        }

        private createForm() {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1", customClass: "vyberovaSkupinaDialogForm", name: "vyberovaSkupinaDialogForm" })
                .addRow("jres:33000441").addField("gselectbox", Gordic.Prefabs.Select.admWflctsu(), { //RC 33000441 : Typ subjektu
                    name: "typ_subj",
                    disabled: true,
                    initialValue: { typ_subj: this.typ_subj }
                }).addRow("jres:33000442").addField("gradio", { //RC 33000442 : Typ skupiny
                    name: "typ",
                    //initialValue: 1,
                    radios: [
                        { value: 0, label: "jres:33000443" }, //RC 33000443 : Vícetypová
                        { value: 10, label: "jres:33000444" } //RC 33000444 : Jednotypová
                    ],
                    change: (ev, obj) => {
                        var ixsBlkField = this.element.findFields("ixs_blk");
                        ixsBlkField.gfield("setValue", null);
                        var serverFilters = {
                            aktivita: 100,
                            pouzePlatne: true,
                        }
                        if (obj.value == 0) {
                            serverFilters["typ"] = 0;
                        } else {
                            serverFilters["typ"] = 10;
                            serverFilters["typ_subj"] = this.typ_subj
                        }
                        ixsBlkField.gfield("option", "serverFilters", serverFilters);
                    }
                }).addRow("jres:33000432").addField("gselectbox", Gordic.Prefabs.Select.admWflsblk(), {
                    name: "ixs_blk",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    buttons: (this.canAddVyberovaSkupina == true) ? [
                        {
                            action: this.actions.actAddVyberovaSkupina
                        }
                    ] : []
                })
            $("<div>").appendTo(this.element).gform("createFrom", form);
            this.element.findFields("typ").gfield("setValue", 10);
        }

        private createNewVyberovaSkupina() {
            var typ = this.element.findFields("typ").gfield("getValue");
            var typ_subj = this.element.findFields("typ_subj").gfield("getValue");
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1", name: "vyberovaSkupinaNazev" })
                .addRow("jres:29931724").addField("gstringbox", Gordic.Prefabs.Field.charCounter(50), {
                    name: "nazev",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addField("gdummyfield", {
                    name: "typ"
                })
                .addField("gdummyfield", {
                    name: "typ_subj"
                })

            this.dialogs.simpleForm((typ == 10) ? "jres:33000446" : "jres:33000447", form, { //RC 33000447 : Nová vícetypová skupina 
                typ: typ,
                typ_subj: typ_subj.typ_subj
            }, {
                width: 500,
                height: 250,
                commandBar: [
                    {
                        action: this.actions.actVyberovaSkupinaCancel
                    },
                    {
                        primary: true,
                        action: this.actions.actVyberovaSkupinaOK
                    }
                ]
            }) 
        }

        private vyberovaSkupinaOK(ev: JQueryEventObject) {
            var cnt = $.content(ev.target);
            cnt.hideFlash("vyberova_skupina_dialog_error");
            var form = cnt.findForms("vyberovaSkupinaNazev");
            if (form.gform("isValid")) {
                var data: Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaSaveDto = {}
                form.findFields().gfield("model", "collect", data);
                if (data.typ == 0)
                    data.typ_subj = 0;
                data.ixs_fun = this.ixs_fun;
                (this.isl.AdmVyberovaSkupina.upsert({ data: data }).get() as any).done((output) => {
                    if (output.result.kind === Utils.GOperationResultKind.Success) {
                        this.notification("showToast", {
                            title: "jres:33000432",
                            content: "jres:33000175",
                            state: "success",
                            icon: "fa-check-circle"
                        })
                        cnt.close();
                        var field = this.element.findForms("vyberovaSkupinaDialogForm").findFields("ixs_blk");
                        field.gselectbox("clearClientCache");
                        field.gfield("setValue", { ixs_blk: output.data.ixs_blk }, false)
                    } else {
                        cnt.showFlash({
                            id: "vyberova_skupina_dialog_error",
                            state: "error",
                            content: "jres:33000448" //RC 33000448 : Výběrovou skupinu s tímto názvem se nepodařilo vytvořit.
                        })
                    }
                })
            }
        }

        private saveDataVyberovaSkupina(ev: JQueryEventObject) {
            var form = this.findForms("vyberovaSkupinaDialogForm");
            if (form.gform("isValid")) {
                var ixs_blk = form.findFields("ixs_blk").gfield("getValue")["ixs_blk"];
                this.data.forEach((item) => {
                    item.ixs_blk = ixs_blk;
                    item.NewRecord = true;
                })
                this.getSrv().call("SaveVyberovaSkupina", { dataVyberoveSkupiny: this.data }).done((output: number) => {
                    this.notification("showToast", {
                        title: "jres:33000450", //RC 33000450 : Data výběrové skupiny
                        content: "jres:33000451".format(output, this.data.length - output), //RC 33000451 : Úspěšně uloženo: {0} <br />Neúspěšně uloženo: {1}
                    })
                    this.close();
                })
            }
        }
    }
}